<template>
<div>
  <div class="heading_group">
      <div class="flex">
        <!--        <span @click="testCD">进入禅道test</span>-->
        <div class="heading_group_welcome">您好，欢迎来到游严选代售！</div>
        <div class="heading_group_btn">
          <router-link class="appDownload" :to="{name:'Download'}">
            <img class="hotApp" src="@/assets/image/Download/hotApp.png">
            IOS安卓双系统APP火热上线<span @click.stop="">&emsp;&emsp;&emsp;&emsp;</span>
          </router-link>
          <router-link tag="div" :to="{name:'PersonalCenter'}" class="registerLogin"
                       v-if="this.$store.state.loginStatus">
            <span class="user_center">个人中心 <span id="message"
                                                 v-show="this.$store.state.message + this.$store.state.unReadMessage>0">{{
                this.$store.state.message + this.$store.state.unReadMessage > 100 ? '99+' : this.$store.state.message + this.$store.state.unReadMessage
              }}</span>&emsp;｜&emsp;</span>
            <div class="head_portrait">
              <!--            <img src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng60a5d6456ddef79d8278c812b71d1067121131f9f768480e2bf992543d7b60a7"/>-->
              <img v-if="this.$store.state.userData.touxiang !== ''" :src="this.$store.state.userData.touxiang"/>
              <img v-else src="@/assets/logo.png"/>
            </div>
            <span class="user_account">&emsp;{{ this.$store.state.userData.nickname }}</span>
          </router-link>
          <router-link tag="a" href="javascript:;" v-else class="register" :to="{name:'Login'}">登录</router-link>
          <a v-if="this.$store.state.loginStatus" href="javascript:;" class="quit" @click="logout">退出</a>
        </div>
      </div>

    </div>
  <div class="main">
    <div class="goback" @click="goBack">
      <img class="back-icon" src="@/assets/image/Download/back.png" alt="">
      <div class="back-text">返回首页</div>
    </div>
    <div class="btnGroup">
      <!-- <img class="qrcode" src="@/assets/image/Download/qrcode.gif" alt=""> -->
      <!-- <router-link class="back" :to="{name:'Home'}">返回网站>></router-link> -->
      <div class="btnGroup-qrcode">
        <img src="@/assets/image/Download/qrcode1.png" alt="" class="app-qrcode-img">
      </div>
      <div class="btnGroup-text">
        <div>手机扫码下载APP</div>
        <div>或在手机应用商店搜索“游严选账号”下载</div>
      </div>
    </div>
    <div class="footer">
      <!-- <img class="footer-logo" src="@/assets/image/Download/APP_logo.png" alt=""> -->
      <div class="footer-info">
        <div class="footer-info-f1">
          <div class="footer-info-f1-item">
            应用名称：游严选账号APP
          </div>
          <div class="footer-info-f1-item footer-info-f1-item2">
            开发运营者：金华市博淳网络科技有限公司
          </div>
          <div class="footer-info-f1-item">
            版本号：v4.2.5
          </div>
        </div>
        <div class="footer-info-f2">
          <div class="footer-info-f2-item" @click="jumpPage()">
            应用涉及权限 <i class="el-icon-arrow-right"></i>
            <!-- <span @click="jumpPage()">查看详情</span> -->
          </div>
          <div class="footer-info-f2-item footer-info-f2-item2" @click="jumpPage()">
            隐私政策 <i class="el-icon-arrow-right"></i>
            <!-- <span @click="jumpPage()">查看详情</span> -->
          </div>
          <div class="footer-info-f2-item" @click="jumpPage()">
            产品功能 <i class="el-icon-arrow-right"></i>
            <!-- <span @click="jumpPage()">查看详情</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { IMDisconnect } from '@/util/im'
import { apiLogout } from '@/request/API'
export default {
  name: "download",
  data(){
    return{
      iosDev:true
    }
  },
  methods:{
    /**
     * 跳转页面
     * @param url
     */
    jumpPage(url){
      window.open(`${process.env.VUE_APP_WEBSITE}/helpDetail?id=279&cat_id=9`,'_blank')
    },
    //返回首页
    goBack(){
      this.$router.push({
        path: '/Home'
      })
    },
    //退出
    logout() {
       //  推广连接需求用户退出后仍能使用channel_code
      let channel_code = sessionStorage.getItem('channel_code')

      if (this.$store.state.loginStatus) {
        apiLogout({
          refresh_token:localStorage.getItem('refresh_token')||''
        }).then(res => {
          IMDisconnect()
          this.$message({
            center: true,
            type: 'success',
            message: "退出成功"
          })
          this.$router.replace('/')
        }).catch(err => {
          this.$message({
            center: true,
            type: 'error',
            message: err.msg
          })
        })
      }
      this.$store.commit('del_token')
      this.$store.state.userData = {}
      this.$store.state.loginStatus = false
      sessionStorage.clear();
       //  推广连接需求用户退出后仍能使用channel_code
      if(channel_code) {
        sessionStorage.setItem('channel_code',channel_code)
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">

/deep/.el-popover{
  left: 32vw;
  bottom: 1vw;
  min-width: auto !important;
}
.qrCodeTip{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Light;
  font-weight: 300;
  color: #000000;
  margin: 9px 0 0;
  img{
    margin: 0 8px 0 0;
  }
}
.heading_group {
    height: 40px;
    // border-bottom: 1px solid #E2E2E2;
    display: flex;
    width: 100vw;
    align-items: center;
    flex-direction: column;
    position: fixed;
    background-color: #fff;

    .flex {
      width: 64%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 40px;

      .heading_group_welcome {
        font-size: 16px;
        color: #5B5B5B;
        float: left;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        // margin-right: 220px;

        a {
          font-size: 16px;
          color: #5B5B5B;
          float: left;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          margin: 0 20px 0 0;
        }
      }

      .heading_group_btn {
        display: flex;

        a {
          padding: 0;
          margin: 0;
        }

        .register {
          font-size: 16px;
          color: #5B5B5B !important;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          margin-left: 10px;
        }

        .registerLogin {
          font-size: 16px;
          color: #5B5B5B !important;
          font-family: PingFangSC-Regular, PingFang SC;
          height: 46px;
          display: flex;
          align-items: center;
          cursor: pointer;

          .user_center {
            display: inline-block;
            position: relative;
            margin-left: 5px;

            #message {
              //min-width: 17px;
              height: 17px;
              line-height: 17px;
              background: #F56B6C;
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              padding: 0 5px;
              position: absolute;
              top: 7px;
              right: 40px;
            }
          }

          .head_portrait {
            width: 30px;
            height: 30px;
            display: inline-block;

            img {
              border-radius: 50%;
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .user_account {
            display: inline-block;
            font-family: PingFangSC-Light, PingFang SC;
          }
        }

        .quit {
          margin: 0 0 0 50px;
          font-size: 16px;
          color: #5B5B5B !important;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
        }

        .appDownload {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FF5400;
          line-height: 22px;

          .hotApp {
            width: 45px;
            height: 20px;
            margin: 0 5px 0 0;
          }

          span {
            font-size: 16px;
            color: #5B5B5B !important;
            font-family: PingFangSC-Regular, PingFang SC;
            cursor: default;
          }
        }
      }
    }
  }
.main {
  height: 100vh;
  width: 100vw;
  background: url("../../assets/image/Download/background1.png") no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .goback{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    position: fixed;
    top: 8%;
    left: 18%;
    .back-icon{
      width: 35px;
      height: 35px;
    }
    .back-text{
      font-size: 20px;
      font-family: Alibaba PuHuiTi 2.0-65 Medium, Alibaba PuHuiTi 20;
      font-weight: normal;
      color: #FFFFFF;
      margin-left: 10px;
    }
  }
  .btnGroup {
    position: fixed;
    top: 30%;
    left: 56%;
    //margin: 32.63vh 0 0 41vh;
    display: flex;
    flex-direction: column;
    .btnGroup-qrcode{
      .app-qrcode-img{
        width: 150px;
        height: 150px;
      }
      &::before{
        position: absolute;
        top: 21%;
        left: 12.5%;
        z-index: 99999;
        content: '';
        width: 80%;
        height: 2px;
        background-color: #F0EDE8;
        animation: upDown 3s linear infinite;
      }
      @keyframes upDown {
        0%{
          top: 10%;
        }
        25%{
          top: 90%;
        }
        50%{
          top: 10%;
        }
        75%{
          top: 90%;
        }
        100%{
          top: 10%;
          // visibility: hidden;
        }
      }
    }
    .btnGroup-text{
      position: absolute;
      width: 252px;
      height: 40px;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      top: 160px;
      left: -52px;
    }
    .btn {
      width: 15.15625vw;
      height: 6.574vh;
    }

    .android {
      margin: 0 0 30px;
      .dev{
        position: absolute;
        top: 20px;
      }
    }

    .ios {
      margin: 0 0 47px;
      position: relative;
      .dev{
        position: absolute;
        top: 20px;
      }
    }

    .qrcode{
      width: 22.685vh;
      height: 27.593vh;
      object-fit: contain;
      margin: 0 0 7vh;
    }

    .back {
      font-size: 14px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #E19D0B;
      text-decoration: underline;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 128px;
    // background: rgba(40,55,72,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    &-logo{
      width: 75px;
      height: 75px;
      margin: 0 55px 0 0;
    }
    &-info{
      &-f1{
        display: flex;
        align-items: center;
        margin: 0 0 16px;
        &-item{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #9B918A;
        }
        &-item2{
          padding: 0 50px;
          margin: 0 48px;
          // border-left: 1px solid #9B918A;
          // border-right: 1px solid #9B918A;
        }
      }
      &-f2{
        display: flex;
        align-items: center;
        &-item{
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #9B918A;
          span{
            color: #F7F5F2;
            text-decoration-line: underline;
            cursor: pointer;
          }
        }
        &-item2{
          margin: 0 100px 0 145px;
        }
      }
    }
  }
}


</style>
